import { CustomModalLayout, Modal, ModalProps } from 'wix-style-react';
import type { FC, ReactNode } from 'react';
import * as React from 'react';

type PopupProps = ModalProps & {
  isOpen: boolean;
  width: number;
  title?: ReactNode;
  onCloseButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
};
export const Popup: FC<PopupProps> = ({
  children,
  isOpen,
  width = 644,
  title,
  onCloseButtonClick,
  dataHook,
}) => {
  return (
    <Modal shouldCloseOnOverlayClick isOpen={isOpen} dataHook={dataHook}>
      <CustomModalLayout
        width={width}
        title={title}
        dataHook={dataHook}
        onCloseButtonClick={onCloseButtonClick}
      >
        {children}
      </CustomModalLayout>
    </Modal>
  );
};
